/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DECPinVM { 
    title?: string | null;
    description?: string | null;
    latitude?: number;
    longitude?: number;
    color?: string | null;
    id?: number;
    level1?: string | null;
    level2?: string | null;
    level3?: string | null;
    level4?: string | null;
    entriesCount?: string | null;
    maleCount?: string | null;
    femaleCount?: string | null;
    isFinalist?: boolean | null;
    isWinner?: boolean | null;
    pinType?: string | null;
    isPublic?: boolean | null;
    hasReadingClub?: boolean | null;
    schoolType1?: string | null;
    schoolType2?: string | null;
    schoolLevel?: string | null;
    instituteType?: string | null;
    english?: number | null;
    noCategory?: number | null;
    art?: number | null;
    kiswahili?: number | null;
    french?: number | null;
    arabic?: number | null;
    german?: number | null;
    ksl?: number | null;
    written?: number | null;
    braille?: number | null;
    spanish?: number | null;
    maleWinners?: number | null;
    femaleWinners?: number | null;
    maleFinalists?: number | null;
    femaleFinalists?: number | null;
    brailleEnglish?: number | null;
    brailleKiswahili?: number | null;
}

